/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Style_Guide_Manager_Partial_Bold_LabelInputs */



/**
* | output |
* | --- |
* | "Partial Bold" |
*
* @param {Style_Guide_Manager_Partial_Bold_LabelInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const style_guide_manager_partial_bold_label = /** @type {((inputs?: Style_Guide_Manager_Partial_Bold_LabelInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Style_Guide_Manager_Partial_Bold_LabelInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("Gras partiel")
	if (locale === "de") return /** @type {LocalizedString} */ ("Teilweise fett")
	if (locale === "it") return /** @type {LocalizedString} */ ("Grassetto parziale")
	if (locale === "ru") return /** @type {LocalizedString} */ ("Частично жирный шрифт")
	if (locale === "es") return /** @type {LocalizedString} */ ("Negrita parcial")
	if (locale === "zh-CN") return /** @type {LocalizedString} */ ("部分粗体")
	if (locale === "ja") return /** @type {LocalizedString} */ ("部分太字")
	if (locale === "hi") return /** @type {LocalizedString} */ ("आंशिक बोल्ड")
	if (locale === "pt-PT") return /** @type {LocalizedString} */ ("Negrito parcial")
	return /** @type {LocalizedString} */ ("Partial Bold")
});